<template>
<div class="chapter">
<div class="inner_page">
<p class="noind" id="dedication">For Monroe and Miriam Cohen,</p>
<p class="noind">with love and thanks</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 4dedication.vue?bdfe423e